/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback } from "react";
import { OfferDealCategoryData } from "../../Utility/Utility";
import getTranslation from "../../TranslationUtility/TranslationUtility";
import { useSelector } from "react-redux";


const FilterModal = ({
  onClose,
  setActiveTab,
  activeTab,
  setAppliedFilters,
  setTagFilters,
  commonDeals,
  dealCouponFilter,
  setIsFetching,
}) => {

  const { filteredDays, filteredByOfferSubType, filteredDealCategories, filteredDeals } = useSelector((state) => state?.dealsDataSlice?.allofferData);
  const translation = getTranslation();
  const getFiltersFromURL = () => {
    const params = new URLSearchParams(window.location.search);
    return {
      validity: params.getAll("validity") || [],
      category: params.getAll("category") || [],
      brand: params.getAll("brand") || [],
      offer: params.getAll("offer") || [],
    };
  };
  const [searchQuery, setSearchQuery] = useState("");
  const [temporaryFilters, setTemporaryFilters] = useState(getFiltersFromURL());

  const updateURL = (filters) => {
    const filterValue = filters.category.filter((val) => val !== "all");
    filters.category = filterValue;
    const params = new URLSearchParams(window.location.search);

    ["validity", "category", "brand", "offer"].forEach((key) =>
      params.delete(key)
    );
    Object.keys(filters).forEach((key) => {
      filters[key].forEach((value) => {
        params.append(key, value);
      });
    });

    window.history.replaceState({}, "", `?${params.toString()}`);
  };

  const handleClearFilters = () => {
    const emptyFilters = { validity: [], category: [], brand: [], offer: [] };
    setTemporaryFilters(emptyFilters);
    setTagFilters(emptyFilters);
    setAppliedFilters(emptyFilters);
    updateURL(emptyFilters);
    setIsFetching(true);
    onClose();
  };

  const handleApplyFilters = () => {
    setTagFilters(temporaryFilters);
    setAppliedFilters(temporaryFilters);
    updateURL(temporaryFilters);
    onClose();
  };

  const toggleFilter = useCallback((type, value) => {
    setTemporaryFilters((prevFilters) => {
      const filters = { ...prevFilters };
      if (filters[type]?.includes(String(value))) {
        filters[type] = filters[type].filter((v) => v !== String(value));
      } else {
        filters[type] = [...filters[type], String(value)];
      }
      return filters;
    });
  }, []);

  useEffect(() => {
    setTemporaryFilters(getFiltersFromURL());
  }, []);

  const filteredDealList = filteredDeals?.filter((deal) =>
    deal.value.toLowerCase().includes(searchQuery.toLowerCase())
  );
  // const filteredDeals = filteredDeals
  const filteredCategories = filteredDealCategories
    ?.filter((category) => {
      const categoryName = String(category?.name || "").trim();
      return categoryName !== "" && categoryName.toLowerCase() !== "all";
    })
    ?.map((category) => ({
      key: category.id,
      value: category.name
    }));
  const filteredOffer = filteredByOfferSubType;

  const renderCheckboxes = (type, options) =>
    options.map((item, index) => {
      const value = item?.key ?? item; // fallback for string values (e.g., offer)
      const label = item?.value ?? item;
      const isChecked = temporaryFilters[type].includes(value) || temporaryFilters[type].includes(String(value));

      return (
        <div key={index} className="flex items-center space-x-3 category-data">
          <input
            type="checkbox"
            className="custom-checkbox"
            value={value}
            checked={isChecked}
            onChange={() => toggleFilter(type, value)}
          />
          <span className="category-data-label" title={label}>
            {label?.length > 20 ? label?.substring(0, 20) + "..." : label}
          </span>
        </div>
      );
    });

  const hasEmiOffers = dealCouponFilter?.some(
    (someData) => someData?.offerSubType === translation?.emi
  );
  const validityOptions = filteredDays?.map((day) => ({
    key: day?.key,
    value: day?.key == 1 ? translation?.validOnlyToday : (day?.key == 2 ? translation?.validOnWeekdays : translation?.validOnWeekends),
  }));

  return (
    <>
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-40"
        onClick={onClose}
      ></div>
      <div className="relative z-50">
        <div className="modal-container fixed md:w-[40%] w-full">
          <div className="p-5 flex justify-between items-center border-b">
            <h2 className="custom-text-size-filters font-bold filter-txt">
              {translation?.filters}
            </h2>
            <button className="Custom-cross-icon" onClick={onClose}>
              <i className="fas fa-times"></i>
            </button>
          </div>
          <div className="flex">
            <div className="w-1/3 category-container">
              {["Validity", "Category", "Brand"]
                .concat(hasEmiOffers ? ["Offer"] : [])
                .map((tab) => (
                  <button
                    key={tab}
                    className={`block w-full custom-category-type ${activeTab === tab
                      ? "category-selected"
                      : "category-not-selected"
                      }`}
                    onClick={() => setActiveTab(tab)}
                  >
                    {tab}
                  </button>
                ))}
            </div>
            <div className="w-2/3">
              {activeTab === "Validity" && (
                <div className="p-4 fltr-h overflow-y-auto">
                  <h2 className="custom-heading">
                    {translation?.checkValidity}
                  </h2>
                  {renderCheckboxes("validity", validityOptions.map((validity) => validity))}
                </div>
              )}
              {activeTab === "Category" && (
                <div className="p-4 fltr-h overflow-y-auto">
                  <h2 className="custom-heading">
                    {translation?.shopByCategory}
                  </h2>
                  {renderCheckboxes(
                    "category",
                    filteredCategories?.map((cat) => cat),
                  )}
                </div>
              )}
              {activeTab === "Brand" && (
                <div className="p-4 fltr-h overflow-y-auto">
                  <h2 className="custom-heading">
                    {translation?.shopByBrands}
                  </h2>
                  <div className="flex items-center brand-searchbar p-2 mb-2 w-full search-brand">
                    <input
                      type="text"
                      placeholder="Search Brand"
                      className="flex-grow border-none outline-none w-full search-input"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <i className="fas fa-search text-gray-400 ml-2"></i>
                  </div>
                  {renderCheckboxes(
                    "brand",
                    searchQuery ? filteredDealList?.map((deal) => deal) : filteredDeals?.map((deal) => deal),
                  )}
                </div>
              )}
              {activeTab === "Offer" && hasEmiOffers && (
                <div className="p-4 fltr-h overflow-y-auto">
                  <h2 className="custom-heading">{translation?.offerLabel}</h2>
                  {renderCheckboxes(
                    "offer",
                    filteredOffer.map((offer) => offer)
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="flex justify-between p-4 border-t custom-shadow">
            <button
              className={`flex-1 button-appclr ${temporaryFilters.validity.length ||
                temporaryFilters.category.length ||
                temporaryFilters.brand.length
                ? "cutome-selected-clr"
                : "cutome-non-selected-clr"
                }`}
              onClick={handleClearFilters}
            >
              {translation?.clearFilter}
            </button>
            <button
              className={`flex-1 button-appclr apply-fsz ${temporaryFilters.validity.length ||
                temporaryFilters.category.length ||
                temporaryFilters.brand.length ||
                temporaryFilters.offer.length
                ? "custome-selected-apply"
                : "custom-non-selected-apply"
                }`}
              onClick={handleApplyFilters}
            >
              {translation?.apply}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterModal;
